import React, { useEffect, useRef } from "react";
import BrowserIntegrationAnimation from "./Animations/BrowserIntegration";
import anime from "animejs/lib/anime.es.js";
import { appsData } from "../../Services/DataService";
import Image from "../../Components/Image";
import CONFIG from "../../Services/ConfigService";
import { gsap } from "gsap";
import Lenis from "@studio-freight/lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./index.scss";
export default function Interactive() {
  const bgWrapperRef = useRef(null);
  const showCaseRef = useRef(null);
  const animationBlock = false;
  const animationScale = false;
  const animationTransform = false;
  // opacity: 0.650344; transform: perspective(1200px) translateX(0px) translateY(0px) scale(1) rotate(0deg) rotateX(20.9794deg) rotateY(0deg) translateZ(0px);
  const initialTransformStyleVal =
    "perspective(1200px) translateX(0px) translateY(0px) scale(1) rotate(0deg) rotateX(20.9794deg) rotateY(0deg) translateZ(0px)";
  const initialOpacityVal = 0.5;
  const animateOnScroll = () => {
    gsap
      .set(".js-showcase", {
        scrollTrigger: {
          trigger: "body",
          scrub: 1,
        },
        transformPerspective: 1200,
        rotationX: 20,
        opacity: 0.65,
      })
      .play();

    /* gsap.set(".js-showcase", {
      scrollTrigger: {
        trigger: "body",
        scrub: 1,
      },
      opacity: initialOpacityVal,
      transform: initialTransformStyleVal,
    });

    //opacity: 0.650344; transform: perspective(1200px) translateX(0px) translateY(0px) scale(1) rotate(0deg) rotateX(20.9794deg) rotateY(0deg) translateZ(0px);

   
    /*gsap
        .timeline({
          scrollTrigger: {
            trigger: ".js-showcase",
            start: "top %20",
            end: "top %100",
            scrub: true,
          },
        })
        .addLabel("start", 0)
        .from(
          ".js-showcase",
          {
            ease: "none",
            perspective: 1200,
            translateX:0,
            translateY:0,
            rotate:0,
            scale:1,
            opacity: 0.1,
          },
          "start"
        )
        .to(
          ".js-showcase",
            {
              ease: "none",
              perspective: 0,
              xPercent:0,
              rotate:0,
              rotateX:20,
              rotateY:0,
              yPercent:0,
              translateZ:0,
              scale:1,
              opacity: 1,
          }
        );*/
  };

  const animateBlocks = () => {
    anime({
      targets: ".block",
      translateX: () => anime.random(-500, 500),
      translateY: () => anime.random(-500, 500),
      scale: () => anime.random(1, 1.2),
      easing: "linear",
      duration: 3000,
      delay: anime.stagger(10),
      complete: animateBlocks,
    });
  };

  const animateScale = () => {
    anime({
      targets: ".js-showcase",
      scale: {
        value: 1,
        duration: 500,
        easing: "easeInOutQuart",
      },
    });
  };

  const BlockCard = ({ item }) => {
    return (
      <div className={`block block--${item.slug}`}>
        <Image fileName={`Assets/Images/Marketplace/${item.image}`} />
      </div>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      animationTransform && animateOnScroll();
      animationScale && animateScale();
      animationBlock && animateBlocks();
    }, 1000);
  }, []);

  const onClickCTA = () => {
    const generateUTMLink =
      CONFIG.APP.REGISTER_URL +
      `?utm_source=${encodeURIComponent(
        window.location.href
      )}&utm_medium=referral&utm_content=js_website-translation_btn`;
    window.location.href = generateUTMLink;
  };

  return (
    <section className="bg-interactive js-section_nav-dark" ref={bgWrapperRef}>
      {animationBlock &&
        appsData.map((item) => {
          return <BlockCard item={item} />;
        })}
      <div className="interactive-section">
        <div className="interactive-section__content">
          <div className="interactive-section__content-wrapper">
            <div className="spot">
              <div className="spot-content">
                <div className="spot-content__title">
                  {/*Makes your <span>website</span> speak any <span>language</span>*/}
                  The <span>simplest</span> way to translate your{" "}
                  <span>website</span>
                </div>

                <div className="spot-content__desc">
                  Translate Your Website in Minutes – Automatically and
                  SEO-Friendly. Boost your global reach with fast, accurate, and
                  automatic translations. No coding required.
                </div>
                <div className="spot-content__cta">
                  <button
                    className="spot-content__cta-btn"
                    onClick={onClickCTA}
                  >
                    Try for Free
                  </button>
                  <span className="spot-content__cta-text">
                    No Credit Card Required
                  </span>
                </div>
              </div>
            </div>
            <div className="showcase js-showcase" ref={showCaseRef}>
              <BrowserIntegrationAnimation showCaseRef={showCaseRef} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
